import { Alert, Button, Stack } from "@mui/material";
import HttpStatus from "http-status-codes";
import { FormEvent, useState } from "react";

import Input, { InputType } from "../../components/forms/Input";
import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";
import useFetch, { FailureHandler } from "../../hooks/useFetch";
import { parseFormErrors } from "../../lib/form";

const SEO_TITLE = "Aanvraag afronden";

const Show = ({ price }: { price: number }) => {
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const handleFailure: FailureHandler = ({ body, json, response }) => {
    if (response?.status === HttpStatus.UNPROCESSABLE_ENTITY) {
      setErrors(parseFormErrors(json, Object.keys(body?.wrap_up ?? {})));
    }
  };
  const [put, { error, loading, submitted }] = useFetch(window.location.href, {
    method: "PUT",
    onFailure: handleFailure,
  });

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const formData = Object.fromEntries(
      new FormData(event.target as HTMLFormElement),
    );

    put({
      wrap_up: {
        ...formData,
        actual_price:
          parseFloat((formData.actual_price as string) ?? "0") * 100,
      },
    });
  };

  if (submitted) {
    return (
      <Main>
        <MetaData title={SEO_TITLE} />
        <p>
          Je aanvraag is afgerond! De gegevens worden doorgestuurd naar jouw
          sponsor zodat die de kosten kan overmaken.
        </p>
      </Main>
    );
  }

  return (
    <Main>
      <MetaData title={SEO_TITLE} />
      <form onSubmit={handleSubmit}>
        <p>Voer jouw rekeninggegevens in en upload jouw bewijs van deelname.</p>
        <p>
          <strong>Let op:</strong> vraag je voor iemand anders
          reiskostenvergoeding aan? Geef dan diens bankgegevens op, zodat we
          kunnen zien dat er niet gefraudeerd wordt.
        </p>
        <Stack spacing={1}>
          <Input
            autoFocus
            required
            error={errors.iban?.[0]}
            label="Wat is jouw rekeningnummer?"
            name="iban"
            type={InputType.Iban}
          />
          <Input
            required
            error={errors.iban_name?.[0]}
            label="Op welke naam staat de rekening?"
            name="iban_name"
            type={InputType.Text}
          />
          <Input
            required
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            defaultValue={(price / 100).toFixed(2)}
            error={errors.actual_price?.[0]}
            helperText="Pas het bedrag aan als deze anders is dan de schatting."
            label="Wat zijn de reiskosten?"
            name="actual_price"
            type={InputType.Euro}
          />
          <Input
            error={errors.comment?.[0]}
            label="Wil je nog iets zeggen tegen jouw sponor?"
            name="comment"
            type={InputType.TextArea}
          />
          <Input
            required
            error={errors.proof?.[0]}
            label="Bewijs van deelname"
            name="proof"
            type={InputType.File}
          />
        </Stack>
        {error && (
          <Alert severity="error" sx={{ marginTop: "1em" }}>
            {error}
          </Alert>
        )}
        <Stack direction="row" justifyContent="end">
          <Button
            loading={loading}
            sx={{ marginTop: "1em" }}
            type="submit"
            variant="contained"
          >
            Opslaan
          </Button>
        </Stack>
      </form>
    </Main>
  );
};

export default Show;
